import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "nome",
    "email",
    "documentoTipo",
    "documento",
    "dataNascimento",
    "beneficiarioType",
    "beneficiarioTipo",
    "beneficiarioId",
  ];

  connect() {
    this.preencherCampos();
  }

  preencherCampos() {
    const currentBeneficiarioId = this.beneficiarioIdTarget.value;
    if (!currentBeneficiarioId) return;

    const beneficiariosBase64 = atob(this.element.dataset.beneficiarios);
    const bytes = Uint8Array.from(beneficiariosBase64, (char) =>
      char.charCodeAt(0)
    );
    const decoder = new TextDecoder("utf-8");
    const beneficiarios = JSON.parse(decoder.decode(bytes));

    const beneficiario = beneficiarios.find(
      (b) => b.beneficiario_id == currentBeneficiarioId
    );

    if (beneficiario) {
      this.nomeTarget.value = beneficiario.nome;
      this.emailTarget.value = beneficiario.email;
      this.documentoTipoTarget.value = beneficiario.documento_tipo;
      this.documentoTarget.value = beneficiario.documento_numero;
      this.dataNascimentoTarget.value = beneficiario.data_nascimento;
      this.beneficiarioTypeTarget.value = beneficiario.beneficiario_type;
      this.beneficiarioTipoTarget.value = beneficiario.beneficiario_tipo;
    }
  }
}
